import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadRichTextDocumentOperation = 'ReadRichTextDocumentV3'

export type ReadRichTextDocumentV3ResponseData = OpalApiResponseDocument<
  ReadRichTextDocumentOperation,
  200
>

export type ReadRichTextDocumentV3RequestParams =
  OpalApiRequestParams<ReadRichTextDocumentOperation>

export type RichTextDocumentInclude =
  ReadRichTextDocumentV3RequestParams['query']['include']

export async function readRichTextDocument(
  params: ReadRichTextDocumentV3RequestParams
): Promise<ReadRichTextDocumentV3ResponseData> {
  const url = new URL(
    `/rich_texts/v3/documents/${params.path.rich_text_document_id}`,
    window.location.origin
  )
  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadRichTextDocumentV3ResponseData>(url.toString())
    .then((res) => res.data)
}
